var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9883 23.8919C48.9849 20.7103 47.8098 17.6601 45.7209 15.4103C43.6319 13.1606 40.7997 11.8951 37.8454 11.8914H29.3426C28.6055 11.843 18.0712 10.9683 8.02978 1.89878C7.40515 1.33399 6.64384 0.97288 5.83527 0.857861C5.0267 0.742842 4.20445 0.878688 3.46507 1.24944C2.7257 1.6202 2.09991 2.21047 1.6612 2.95094C1.22249 3.6914 0.989072 4.55131 0.988366 5.42967V42.3541C0.98321 43.2335 1.21378 44.0958 1.65242 44.8375C2.09105 45.5793 2.71911 46.1689 3.46122 46.5358C4.20016 46.9115 5.02391 47.0501 5.83405 46.9351C6.64419 46.8201 7.40646 46.4563 8.02978 45.8873C13.1695 41.2341 19.2843 37.9992 25.8455 36.4623V42.5087C25.8454 43.2684 26.0194 44.0164 26.3521 44.6862C26.6847 45.3561 27.1658 45.9272 27.7526 46.3489C27.8477 46.4179 27.9473 46.4796 28.0505 46.5335L31.1447 48.1628C31.7167 48.5315 32.3606 48.7515 33.0253 48.8052C33.69 48.8589 34.3572 48.7449 34.9738 48.4722C35.5904 48.1996 36.1395 47.7757 36.5774 47.2345C37.0152 46.6932 37.3298 46.0494 37.4962 45.3542L39.8726 35.7031C42.4332 35.1897 44.7463 33.7277 46.4112 31.5706C48.0761 29.4134 48.9878 26.6969 48.9883 23.8919ZM6.13121 40.4225V7.36821C13.8819 13.8461 21.5962 16.1608 25.8455 16.9824V30.8152C21.5962 31.6275 13.8819 33.9422 6.13121 40.4225ZM32.7862 42.8618L30.9883 41.9156V35.8923H34.5026L32.7862 42.8618ZM37.8454 30.3537H30.9883V17.4301H37.8454C39.4367 17.4301 40.9629 18.1109 42.0881 19.3227C43.2133 20.5345 43.8454 22.1781 43.8454 23.8919C43.8454 25.6057 43.2133 27.2492 42.0881 28.461C40.9629 29.6729 39.4367 30.3537 37.8454 30.3537Z",
    fill: "url(#paint0_linear_1565_11669)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_11669",
    x1: 24.9883,
    y1: 0.818115,
    x2: 24.9883,
    y2: 48.8181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/Speaker.6bc44185aa9795bbad55f5c0cd1f5276.svg";
export { ForwardRef as ReactComponent };